
import { useState } from 'react';

export default function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href="https://api.whatsapp.com/send?phone=905326230183&text=Merhaba, sürdürülebilirlik danışmanlığı hizmetleriniz hakkında bilgi almak istiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="w-14 h-14 flex items-center justify-center rounded-full">
          <i className="ri-whatsapp-line text-2xl"></i>
        </div>
        
        <div className={`overflow-hidden transition-all duration-300 ${
          isHovered ? 'max-w-xs pr-4' : 'max-w-0'
        }`}>
          <span className="whitespace-nowrap text-sm font-medium">
            WhatsApp ile İletişim
          </span>
        </div>
      </a>
      
      {/* Pulse effect */}
      <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20 pointer-events-none"></div>
      
      {/* Chat bubble animation */}
      <div className={`absolute -top-12 left-1/2 transform -translate-x-1/2 bg-white rounded-lg px-3 py-2 shadow-lg transition-all duration-300 ${
        isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      }`}>
        <div className="text-xs text-gray-700 whitespace-nowrap">
          Hemen mesaj gönderin!
        </div>
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white"></div>
      </div>
    </div>
  );
}
